<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    :disabled="dialogVisible"
  >
    <!-- 未开始-0 或 已结束-2  -->
    <div
      v-if="activityInfo.activeStatus === 0 || activityInfo.activeStatus === 2"
      :class="$style.pageNative"
    >
      <img
        v-if="activityInfo.activeStatus === 0"
        :src="`${CDN_URL_1}/box_subscribe/unStart.png`"
      />
      <div v-if="activityInfo.activeStatus === 0" :class="$style.nativeStatus">
        活动将于{{ activityInfo.startTime }}开始
      </div>
      <img
        v-if="activityInfo.activeStatus === 2"
        :src="`${CDN_URL_1}/box_subscribe/end.png`"
      />
      <div v-if="activityInfo.activeStatus === 2" :class="$style.nativeStatus">
        活动已结束
      </div>
    </div>

    <!-- 进行中-1  -->
    <div
      v-if="activityInfo.activeStatus === 1"
      :class="`${$style.pageContent}`"
    >
      <div :class="$style.activityInfo">
        <div :class="$style.gameImage">
          <img :src="activityInfo.icon" />
        </div>
        <div :class="$style.activityPlaces">
          <div v-if="gamePlaces.length > 0">
            <div
              v-for="item in gamePlaces.slice(0, 5)"
              :key="item.gameId"
              :style="{ display: 'inline-block', position: 'relative' }"
            >
              <img
                :src="item.gameIcon"
                :class="`${$style.placeIcon} ${
                  item.gameId == selectPlaceId ? $style.activePlace : ''
                }`"
                @click="onHandlePlace(item)"
              />
              <!-- <div v-if="item.playing" :class="$style.isPlay">最近在玩</div> -->
            </div>
          </div>
          <div
            v-if="gamePlaces.length > 5"
            :class="$style.morePlace"
            @click="openDialog(1)"
          >
            <img :src="`${CDN_URL_1}/box_payAmount/more.png`" />
            <p :class="$style.moreText">更多游戏</p>
          </div>
        </div>
      </div>
      <div :class="$style.gameWrapper" @touchmove.stop @touchend.stop>
        <div style="position: relative">
          <div :class="$style.gameInfo">
            <div :class="$style.title">
              {{ curPlaceInfo.gameName }}
            </div>
            <span :class="$style.tag">{{ curPlaceInfo.tag }}</span>
            <div
              :class="$style.button"
              @click="onSkipDetail(curPlaceInfo.gameId)"
            >
              下载/查看游戏
            </div>
          </div>
        </div>

        <div :class="$style.giftWrapper">
          <div :class="$style.title">每日进入夺宝榜单第1名</div>
          <div :class="$style.seal">
            <img :src="`${CDN_URL_1}/box_win/2.png`" />
          </div>
          <div :class="$style.info">
            <img :src="curPlaceInfo.firstGiftIcon" />
            <p>{{ curPlaceInfo.firstGiftContent }}</p>
          </div>
        </div>

        <div :class="$style.giftWrapper">
          <div :class="$style.title">每日进入夺宝榜单前10名</div>
          <div :class="$style.seal">
            <img :src="`${CDN_URL_1}/box_win/2.png`" />
          </div>
          <div :class="$style.info">
            <img :src="curPlaceInfo.tenGiftIcon" />
            <p>{{ curPlaceInfo.tenGiftContent }}</p>
          </div>
        </div>

        <div :class="$style.giftWrapper">
          <div :class="$style.title">每日进入夺宝榜单</div>
          <div :class="$style.seal">
            <img :src="`${CDN_URL_1}/box_win/2.png`" />
          </div>
          <div :class="$style.info">
            <img :src="curPlaceInfo.giftIcon" />
            <p>{{ curPlaceInfo.giftContent }}</p>
          </div>
        </div>
        <div :class="$style.joinButton" :style="{filter: joinGameId!= selectPlaceId && joinGameId ? 'grayscale(1)': 'none'}" @click="onJoinActivity">参与夺宝</div>
      </div>

      <!-- 弹窗 -->
      <ActivityDialog
        :title="dialogTitle"
        :visible="dialogVisible"
        :hideCancel="dialogType == 1"
        :hideSure="dialogType == 1"
        :cancelText="cancelText"
        :sureText="sureText"
        @click-sure="onSureDialog"
        @click-cancel="dialogVisible = false"
        :herderStyle="{ background: '#ffb503' }"
        :cancelStyle="{ filter: 'none' }"
        :dialogStyle="{ top: dialogType == 1 ? '16%' : '32%' }"
      >
        <template v-slot:main>
          <!-- 更多游戏弹窗 -->
          <div v-if="dialogType == 1" :class="$style.dialog1">
            <h3 v-if="gamePlaces.filter((ele) => ele.playing).length > 0" :class="$style.dialogTitle">在玩游戏</h3>
            <div :class="$style.dialogPlace">
              <div
                v-for="item in gamePlaces.filter((ele) => ele.playing)"
                :key="item.gameId"
                :class="$style.item"
                @click="onHandlePlace(item)"
              >
                <img :src="item.gameIcon" :class="$style.icon" />
                <div :class="$style.name">{{ item.gameName }}</div>
              </div>
            </div>
            <h3 v-if="gamePlaces.filter((ele) => !ele.playing).length > 0" :class="$style.dialogTitle">推荐游戏</h3>
            <div :class="$style.dialogPlace">
              <div
                v-for="item in gamePlaces.filter((ele) => !ele.playing)"
                :key="item.gameId"
                :class="$style.item"
                @click="onHandlePlace(item)"
              >
                <img :src="item.gameIcon" :class="$style.icon" />
                <div :class="$style.name">{{ item.gameName }}</div>
              </div>
            </div>
          </div>
          <div v-if="dialogType == 2" :class="$style.dialog4">
            <p :style="{ textAlign: 'center' }">
              活动期间只能选择<span style="font-weight: bold">1</span
              >款游戏参与,
            </p>
            <p>参与后不可更改</p>
            <p>
              要确认参与<span>《{{ curPlaceInfo.gameName }}》</span>的夺宝活动吗
            </p>
          </div>
        </template>
      </ActivityDialog>
    </div>
  </PullRefresh>
</template>

<script>
import { inithandler } from "@/bridge/jsBridge";
import { CDN_URL_1, CDN_URL } from "@/config";
import {
  setPageTitle,
  toLogin,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
  loginSuccess,
  phoneBackButtonListener,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import ActivityDialog from "@/components/btBox/ActivityDialog";
import { getCookie } from "@/libs/utils";
import {
  getWinTreasureInfoApi,
  getWinTreasurePlaceApi,
  signInWinTreasureApi,
  getWinTreasureDetailApi,
} from "@/apis/wxActivity";
import { burnPoint } from "@/apis/heziShare";

export default {
  name: "",
  components: {
    PullRefresh,
    ActivityDialog,
  },
  data() {
    return {
      CDN_URL_1: CDN_URL_1,
      CDN_URL: CDN_URL,
      pageTitle: "",
      activityId: "",
      isLoading: false,
      cookie: null,
      activityInfo: {
        join: false,
        startTime: "",
        banner: "",
        icon: "",
        activeStatus: 1,
      },
      gamePlaces: [],
      selectPlaceId: "",
      joinGameId:"",
      curPlaceInfo: {
        gameIcon: "",
        gameName: "",
        gameTag: "",
        gameId: "",
      },
      giftList: [],
      dialogVisible: false,
      dialogType: 1, // 1-更多游戏 2-温馨提醒
      dialogTitle: "更多游戏",
      sureText: "",
      cancelText: "",
    };
  },
  created() {
    // 页面初始化
    try {
      inithandler();
    } catch (error) {
      console.log("🚀 ~ file: inithandler ~ error:", error);
    }
    // this.initPageData();
    loginSuccess(() => {
      this.initPageData();
    })
  },
  activated() {
    setRightTxt("活动规则");
    this.initPageData();
  },
  watch: {},
  methods: {
    // 下拉刷新
    async onRefresh() {
      this.gamePlaces = [];
      this.selectPlaceId = '';
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      if (!this.activityId) {
        return
      }
      console.log("正常数据上报", data.event);
      burnPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 获取缓存等携带的用户信息数据
    async initPageData() {
      this.setHeaderContent();
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 获取token
      this.getAppToken();
    },
    // 获取登录态
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getActivityMainConfig();
      } else {
        toLogin("/loginKey/LoginByKeyPhoneActivity");
      }
    },

    // 获取活动主配置
    getActivityMainConfig() {
      getWinTreasureInfoApi()
        .then((res) => {
          const { data } = res;
          this.pageTitle = data.title;
          setPageTitle(data.title);
          this.activityInfo = data;
          this.activityId = data.id;
          if (data.activeStatus == 1) {
            this.getActPlaces(data.id);
          }
          if (data.join) {
            this.joinGameId = data.gameId;
            this.onSkipActDetail();
          }
          this.eventTrack({
            event: "seize_place_page",
            event_field: JSON.stringify({
              act_id: this.activityId,
              act_name: data.title,
            }),
          });
        })
        .catch((err) => {
          const { response } = err;
          if (response) {
            const { data } = response;
            if (data && data.code === 401) {
              toLogin("/loginKey/LoginByKeyPhoneActivity");
            }
          }
        });
    },

    // 点击游戏会场
    onHandlePlace({ gameId, playing }) {
      this.selectPlaceId = gameId;
      if (this.gamePlaces.length > 0) {
        let place = {};
        let placeIndex = 0;
        this.gamePlaces.map((item, index) => {
          if (item.gameId == gameId) {
            placeIndex = index;
            place = item;
            this.curPlaceInfo = item;
          }
        });
        const arr = this.gamePlaces.filter((ele, index) => index != placeIndex);
        this.gamePlaces = [place, ...arr];
      }
      this.dialogVisible = false;
      this.eventTrack({
        event: "seize_place_page_game_icon",
        event_field: JSON.stringify({
          act_id: this.activityId,
          act_name: this.pageTitle,
          is_play: playing ? 1 : 2,
        }),
        appName: this.curPlaceInfo.gameName,
        appkey: this.curPlaceInfo.gameId,
      });
    },

    // 获取游戏会场礼包信息
    getActPlaces(activeId, cb) {
      getWinTreasurePlaceApi({ activeId })
        .then((res) => {
          const { data } = res;
          if (data && this.gamePlaces.length == 0) {
            this.gamePlaces = data;
          }
          if (!this.selectPlaceId) {
            this.selectPlaceId = data[0].gameId;
            this.curPlaceInfo = data[0];
          }
          cb && cb();
        })
        .catch((err) => {
          console.log("err:", err);
        });
    },

    // 点击参与夺宝
    onJoinActivity() {
      if (this.activityInfo.join) {
        if (this.joinGameId != this.selectPlaceId) {
          return;
        }
        this.onSkipActDetail();
      } else {
        this.eventTrack({
          event: "seize_treasures_join",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
          appName: this.curPlaceInfo.gameName,
          appkey: this.curPlaceInfo.gameId,
        });
        this.openDialog(2);
        this.eventTrack({
          event: "seize_treasures_join_sure_pop",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
          appName: this.curPlaceInfo.gameName,
          appkey: this.curPlaceInfo.gameId,
        });
      }
    },

    // 打开弹窗
    openDialog(type, isReceived = false) {
      this.dialogVisible = true;
      this.dialogType = type;
      if (type == 1) {
        this.dialogTitle = "请选择";
        this.eventTrack({
          event: "seize_place_page_more_game",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
        });
        return;
      }
      if (type == 2) {
        this.dialogTitle = "温馨提醒";
        this.sureText = "确认";
        this.cancelText = "我再想想";
      }
    },

    // 确认弹窗
    onSureDialog() {
      this.dialogVisible = false;
      if (this.dialogType == 2) {
        this.eventTrack({
          event: "seize_treasures_join_sure_enter",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
          appName: this.curPlaceInfo.gameName,
          appkey: this.curPlaceInfo.gameId,
        });
        signInWinTreasureApi({
          activeId: this.activityId,
          gameId: this.selectPlaceId,
        }).then((res) => {
          this.onSkipActDetail();
        });
      }
    },

    // 跳转活动详情
    onSkipActDetail() {
      this.$router.push({
        name: `box.wxWinTreasures.detail`,
        query: {
          activityId: this.activityId,
          activityName: this.pageTitle,
        },
      });
    },

    // 游戏详情
    onSkipDetail(gameId) {
      this.eventTrack({
        event: "seize_place_page_look_game",
        event_field: JSON.stringify({
          act_id: this.activityId,
          act_name: this.pageTitle,
        }),
        appName: this.curPlaceInfo.gameName,
        appkey: this.curPlaceInfo.gameId,
      });
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: 40,
        extraParams: gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },

    // 设置顶部内容
    setHeaderContent() {
      setRightTxtColor("#6879AD");
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.$router.push({
          name: `box.actPlaceRule`,
          params: {
            type: 21,
          },
        });
        this.eventTrack({
          event: "seize_place_page_rule",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
        });
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageContent {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  overflow: auto;
  background-size: cover;
  background: #f6f6f6;
  position: relative;

  .dialog1 {
    max-height: 334px;
    overflow: auto;
    .dialogTitle {
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      color: #ff5216;
      text-align: left;
      padding-left: 10px;
    }
    .dialogPlace {
      display: flex;
      flex-wrap: wrap;
      margin-top: 18px;

      .item {
        width: 32%;
        margin-bottom: 14px;
        position: relative;
      }
      .icon {
        width: 58px;
        height: 58px;
      }
      .name {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
    }
  }

  .dialog2 {
  }
  .activityInfo {
    margin: 7px 10px;
    .gameImage {
      display: inline-flex;
      > img {
        border-radius: 7px;
        width: 100%;
      }
    }
    .activityPlaces {
      width: 100%;
      height: 101px;
      background: #ffffff;
      border-radius: 7px;
      display: flex;
      align-items: flex-end;
      padding-bottom: 8px;
      position: relative;
      margin-top: 7px;
      .placeIcon {
        width: 48px;
        margin-left: 8px;
      }
      .activePlace {
        width: 62px !important;
      }
      .morePlace {
        width: 48px;
        margin-left: 8px;
        text-align: center;
        > img {
          width: 34px;
        }
        .moreText {
          font-weight: 500;
          text-align: center;
          color: #fc5f5e;
          font-size: 12px;
          margin-top: 2px;
          transform: scale(0.9);
        }
      }
    }
  }

  .gameWrapper {
    // width: 100%;
    // height: 500px;
    min-height: 136px;
    border-radius: 13.89px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-bottom: 30px;
    margin: 7px 10px;
    background: linear-gradient(181deg, #fff2e9 0%, #ffffff 99%);
    .gameInfo {
      display: flex;
      // padding: 10px 13px 10px;
      align-items: flex-end;
      justify-content: space-between;
      .title {
        font-size: 19px;
        font-weight: 700;
        height: 40px;
        line-height: 40px;
        width: 139px;
        text-align: left;
        color: #a1583e;
        position: relative;
        background: linear-gradient(180deg, #ffdac8 0%, #fff2ea 100%);
        border-radius: 6.94px 19.79px 19.79px 0px;
        padding-left: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
      }
      .tag {
        height: 18px;
        line-height: 20px;
        padding: 0 9px;
        background: #ff6d6d;
        border-radius: 2px;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        position: absolute;
        left: 124px;
        top: 50%;
        transform: translateY(-50%);
        display: block;
        width: max-content;
      }
      .button {
        width: 118px;
        height: 30px;
        line-height: 30px;
        background: linear-gradient(
          44deg,
          rgba(255, 85, 11, 0.87) 0%,
          rgba(255, 132, 21, 0.87) 90%
        );
        border-radius: 13px;
        font-size: 15px;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        margin-right: 10px;
      }
    }
    .giftWrapper {
      height: 100px;
      background: #ffffff;
      border: 2px solid #ff9d38;
      border-radius: 7px;
      margin: 10px;
      position: relative;
      .title {
        width: 224px;
        height: 30px;
        background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_win/titleBg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin: auto;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        font-size: 15px;
        text-align: center;
        line-height: 30px;
      }
      .seal {
        width: 52px;
        height: 51px;
        background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_win/1.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 1px;
        right: 3px;
        > img {
          width: 27px;
          display: block;
          position: relative;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
      .info {
        display: flex;
        align-items: flex-end;
        margin: 6px 19px 2px;
        > img {
          width: 48px;
        }
        > p {
          text-align: left;
          color: #9f7155;
          line-height: 12.5px;
          font-weight: 500;
          font-size: 12px;
          transform: scale(0.9);
          line-height: 1.1;
        }
      }
    }
    .joinButton {
      width: 300px;
      height: 44px;
      background: linear-gradient(
        44deg,
        rgba(255, 85, 11, 0.87) 0%,
        rgba(255, 132, 21, 0.87) 90%
      );
      border-radius: 22px;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      margin: 18px auto 0px;
      line-height: 44px;
    }
  }
  .isPlay {
    position: absolute;
    top: -18px;
    left: 42px;
    background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_payAmount/tips.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 30px;
    line-height: 24px;
    font-size: 12px;
    color: #fefefe;
    width: 64px;
    text-align: center;
    z-index: 1;
  }
}
.pageNative {
  position: relative;
  height: calc(100vh - 1px);
  > img {
    width: 100%;
    height: calc(100vh - 1px);
  }
  .nativeStatus {
    width: 375px;
    height: 39.24px;
    line-height: 39.24px;
    position: absolute;
    top: calc(50% - 39px);
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    font-size: 18.75px;
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.1)
    );
    letter-spacing: 1px;
  }
}
</style>
